import { useEffect, useState } from 'react';
import throttle from 'lodash/throttle';
function getIsVisibleOrNear(element, nearDistance) {
    var rect = element === null || element === void 0 ? void 0 : element.getBoundingClientRect();
    // SSR or not rendered yet
    if (!rect || typeof window === 'undefined') {
        return true;
    }
    var topOffset = rect.y - window.innerHeight;
    var bottomOffset = rect.y + rect.height;
    // below viewport
    if (topOffset > 0) {
        return Math.abs(topOffset) < nearDistance;
    }
    // above viewport
    if (bottomOffset < 0) {
        return Math.abs(bottomOffset) < nearDistance;
    }
    // near viewport
    return true;
}
export function useRowVisibility(ref, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.enabled, enabled = _c === void 0 ? true : _c, _d = _b.nearDistance, nearDistance = _d === void 0 ? typeof window === 'undefined' ? 0 : window.innerHeight : _d, _e = _b.throttleMs, throttleMs = _e === void 0 ? 375 : _e;
    var _f = useState(true), isVisible = _f[0], setIsVisible = _f[1];
    useEffect(function () {
        if (!enabled) {
            return;
        }
        var updateVisibility = throttle(function () { return setIsVisible(getIsVisibleOrNear(ref.current, nearDistance)); }, throttleMs, { leading: true, trailing: true });
        updateVisibility();
        window.addEventListener('scroll', updateVisibility, { passive: true });
        return function () { return window.removeEventListener('scroll', updateVisibility); };
    }, [enabled, nearDistance, throttleMs, ref]);
    return isVisible;
}
//# sourceMappingURL=useRowVisibility.js.map